<template>
  <div class="appointment-confirmation-modal">
    <dx-modal title="Confirmação de agendamento"
              :value="show" @input="close" id="modal-confirmation-list">
      <div class="columns card-group">
        <div class="column col-6">
          <small>Data e hora</small>
          <div class="card-value">{{ data.date | date('DD/MM/YYYY HH:mm') }}</div>
        </div>
        <div class="column col-6">
          <small>Status</small>
          <div class="card-value">{{ getName(data.status) }}</div>
        </div>
        <div class="column col-12 form-group divider" />
        <div class="column col-12">
          <small>Profissional</small>
          <div class="card-value">{{ data.professionalName }}</div>
        </div>
        <div class="column col-12 form-group divider" />
        <div class="column col-6">
          <small>Paciente</small>
          <div class="card-value">{{ data.patientName }}</div>
        </div>
        <div class="column col-6">
          <small>Convênio</small>
          <div class="card-value">{{ data.insuranceName }}</div>
        </div>
      </div>
      <div class="divider" />
      <div v-if="data.expenses && data.expenses.length > 0">
        <small>Serviços, taxas e outras despesas</small>
      </div>
      <table class="table table-hover" v-if="data.expenses && data.expenses.length > 0">
        <tbody>
        <tr v-for="(item, i) in data.expenses" :key="i">
          <td width="20px">{{ item.expense.code | tuss }}</td>
          <td>{{ item.expense.name }}</td>
          <td class="text-center">{{ item.quantity }}x</td>
          <td class="text-right">
            {{ item.totalParticular | currency }}
          </td>
        </tr>
        </tbody>
      </table>
      <div class="text-right text-bold mr-2 mt-2">{{ total | currency }}</div>
      <template #footer>
        <button
          class="btn btn-neutral btn-icon btn-appointment tooltip float-left"
          data-tooltip="Enviar link de cadastro para o paciente"
          :disabled="!canSendWhatsappWebMessage"
          @click="sendWhatsappWebPatientLink"
        ><fa-icon :icon="['fal', 'address-card']"></fa-icon></button>
        <button
          class="btn btn-primary mr-2"
          :class="{ loading: printing }"
          @click="print"
        >Imprimir</button>
        <button class="btn" @click="close">Sair</button>
      </template>
    </dx-modal>
  </div>
</template>

<script>
import { getName } from '@/data/appointment-statuses';
import { mapGetters } from 'vuex';

export default {
  props: {
    show: {
      type: Boolean,
    },
    data: {
      isExam: {
        type: Boolean,
      },
      appointmentId: {
        type: String,
      },
      date: {
        type: Date,
      },
      status: {
        type: String,
      },
      professionalName: {
        type: String,
      },
      patientName: {
        type: String,
      },
      insuranceName: {
        type: String,
      },
      expenses: {
        type: Array,
      },
      whatsapp: {
        type: Object,
      },
    },
  },
  data() {
    return {
      getName,
      printing: false,
    };
  },
  computed: {
    ...mapGetters({
      branchSettings: 'branchSettings',
    }),
    isWhatsappWebEnabled() {
      return this.branchSettings.whatsappWeb.enabled;
    },
    canSendWhatsappWebMessage() {
      return this.isWhatsappWebEnabled && !!this.data.whatsapp.number;
    },
    total() {
      return this.data.expenses
        .reduce((a, b) => a + b.totalParticular, 0);
    },
  },
  methods: {
    sendWhatsappWebPatientLink() {
      this.$whatsappWeb.open(this.data.whatsapp.number, this.data.whatsapp.text);
    },
    print() {
      this.printing = true;
      return this.$file
        .print('/appointments/print-appointment', { id: this.data.appointmentId })
        .catch(this.$toast.error)
        .finally(() => {
          this.printing = false;
        });
    },
    close() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss">
  @import '../../../../assets/scss/variables';
  #modal-confirmation-list {
    .card-group {
      .card-value {
        color: $primary-color;
        font-weight: bold;
      }
    }
    .table td {
      font-size: 0.54rem;
    }
  }
</style>
